import { render, staticRenderFns } from "./ContentAssessor.vue?vue&type=template&id=49e76186&"
import script from "./ContentAssessor.vue?vue&type=script&lang=js&"
export * from "./ContentAssessor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports